import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CommonService } from '../common.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { BrowserModule } from '@angular/platform-browser';
declare let swal: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
declare var $: any;
@Component({
  selector: 'app-users-management',
  templateUrl: './users-management.component.html',
  styleUrls: ['./users-management.component.css']
})
export class UsersManagementComponent implements OnInit {
  returnUrl = "/dashboard/addusermanagement";
  samepageroute = "/dashboard/usermanagement";
  viewurl = "/dashboard/ViewUserManagement";
  editurl = "/dashboard/EditUserManagement";
  getuserListData: any = [];
  getlistApi: any;
  dataString: any;
  userrole: any;
  addUrl: any;
  loginresponse: any;
  farm_userrole: any;
  isDisabled: boolean = false;
  isDisableddirector: boolean = false;
  isDisabledadmin: boolean = false;
  farm_user: any;
  isLoading = false;
  admindisabledelete: any;
  constructor(private router: Router, private commonService: CommonService) { }

  async ngOnInit() {
    $('.selectpicker').selectpicker('refresh');
    this.isLoading = true;
    var table;
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole = this.loginresponse.read_status;
    this.farm_userrole = this.loginresponse.user_farm_id;
    this.admindisabledelete = this.loginresponse.user_role;
    console.log(this.farm_userrole)
    if (this.userrole == 1) {
      this.isDisabled = true;
      $(".edit").removeAttr("id"); // Element(s) are now enabled.
      console.log('TRUE',this.isDisabled)
    }
    if (this.admindisabledelete === 'Admin') {
      this.isDisabledadmin = true;
      $(".edit").removeAttr("id"); // Element(s) are now enabled.
      console.log('TRUE',this.isDisabledadmin)

    }
    if (this.admindisabledelete === 'Director') {
      this.isDisableddirector = this.admindisabledelete;
    }

    /*if(this.userrole==0){
     this.isDisabled=false;
      // $(".edit").removeAttr("id"); // Element(s) are now enabled.
    }*/
    this.farm_user = this.farm_userrole;
    if (this.farm_userrole) {
      this.isDisabled = true;
      this.getlistApi = "/user_management/?farm_user=" + this.farm_user;
    }
    else {
      this.getlistApi = "/user_management";
    }
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {

        $(function () {
          table = $("#myTable").DataTable();
        })
        this.getuserListData = res.data;
        setTimeout((res) => {
          this.isLoading = false;
        }, 500);

      })

    $('#speciessearch').on('keyup', function () {
      var inputValue = (<HTMLInputElement>document.getElementById('speciessearch')).value;
      table.search(inputValue).draw();
    });

  }
  viewusermanagement(e) {
    console.log(e.target.id);
    sessionStorage.setItem('userId', e.target.id);
    this.router.navigate([this.viewurl]);
  }
  edituserManagement(e) {
    console.log(e.target.id);
    sessionStorage.setItem('userId', e.target.id)
    this.router.navigate([this.editurl]);
  }
  addusermanagement() {
    //this.router.navigate([this.returnUrl]);
    this.router.navigateByUrl('/dashboard', { skipLocationChange: true }).then(() => {
      this.router.navigate([this.returnUrl]);
    });
  }
  async sweetdelete(e) {
    Swal.fire({
      title: 'Are you sure you want to delete the User record ?',
      //text: 'You will not be able to recover this file!',  
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(async (result) => {
      if (result.value) {
        console.log(e.target.id);
        var deleteurl = "/user_management/" + e.target.id;
        (await this.commonService.deleteApi(deleteurl)).subscribe(
          res => {
            Swal.fire(
              'Deleted!',
              'The User record has been deleted successfully',
              'success'
            );
            let currentUrl = this.samepageroute;
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate([currentUrl]);
            });

          });

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'The User record has not been deleted',
          'error'
        )
      }
    })
    console.log('Status')
  }

  async onFileChange(ev) {
    console.log('test');
    console.log(ev);
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = async (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      this.dataString = jsonData;
      //        let value:any=dataString;
      console.log(this.dataString);
      console.log(this.dataString.data);
      /*$.each(dataString[0], function(key, value){
        console.log(key, value);
        console.log(key);
        console.log(value);
    });*/
      this.addUrl = "/species";
      (await this.commonService.postApi(this.addUrl, this.dataString.data)).subscribe(
        data => {
          alert(data.message);
        });

      // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");

    }
    reader.readAsBinaryString(file);
  }
  exportspecies() {
    var downloadtabledata = this.getuserListData;
    var resultarry = downloadtabledata.map((ele) => {
      if (ele.tnus_status == 1) {
        var statusc = "Active";
      } else {
        var statusc = "Inactive";
      }
      return { "User name": ele.tnus_name, "User role": ele.tnus_role, "User Id": ele.tnus_user_code, "User email": ele.tnus_email, "Contact number": ele.tnus_contact_no, "department": ele.tnus_department, "Farm name": ele.farm_name, "Status": statusc }
    })
    console.log(resultarry);
    this.exportAsExcelFile(resultarry, 'user');
  }
  public exportAsExcelFile(json: any[], excelFileName: string): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet', worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
  
}
